import {useQuery} from '@apollo/client';
import {GetWithdrawalReason} from '../schema-types/GetWithdrawalReason';
import {GET_WITHDRAWAL_REASON} from '../features/goals/goalsQueries';

const useWithdrawalReason = () => {
  const {
    data,
    error: withdrawalReasonError,
    loading: withdrawalReasonLoading,
    refetch,
  } = useQuery<GetWithdrawalReason>(GET_WITHDRAWAL_REASON);

  return {
    withdrawalReason: data?.getCuroCodes,
    withdrawalReasonError,
    withdrawalReasonLoading,
  };
};

export default useWithdrawalReason;
